import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { InitService } from '../init/init.service';
import { TranslateService } from 'src/app/shared/translate.service';
import { AppConfiguration } from 'src/app/app.configuration';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit {
  pedido;
  constructor(
    private route: ActivatedRoute,
    private initService: InitService,
    private translateService: TranslateService,
    private configService: AppConfiguration
  ) {}

  ngOnInit() {
    const lastLang = localStorage.getItem('lastLang') || this.translateService.getLocale() || 'es-ES';
    this.translateService.use(lastLang, this.configService.getProyecto());

    if (this.route.snapshot.params.datosPago) {
      const datosPago = JSON.parse(this.initService.funcionDesencript(this.route.snapshot.params.datosPago));
      this.pedido = datosPago.pedido;
    } else if (this.route.snapshot.params.pedido) {
      this.pedido = this.route.snapshot.params.pedido;
    } else if (sessionStorage.getItem('pedido')) {
      this.pedido = sessionStorage.getItem('pedido');
    }
    sessionStorage.removeItem('factura');
    sessionStorage.removeItem('descuento');
    sessionStorage.removeItem('pedido');
    sessionStorage.removeItem('localizador');
    sessionStorage.removeItem('payment');
    sessionStorage.removeItem('estaPagada');
    sessionStorage.removeItem('aceptaCookies');
  }
}
